import { FaCheck } from 'react-icons/fa';
import { cn } from '../../../utils/cn';
import type { ChecklistItem } from '../types';
import { ProgressBar } from './primitives';

export const Checklist: React.FC<{
  items: ChecklistItem[];
  onToggle?: (itemId: string, done: boolean) => void;
  readOnly?: boolean;
}> = ({ items, onToggle, readOnly = false }) => {
  const doneCount = items.filter((i) => i.done).length;
  const requiredRemaining = items.filter((i) => i.required && !i.done).length;
  const pct = items.length ? (doneCount / items.length) * 100 : 0;

  return (
    <div>
      <div className="mb-3 flex items-center justify-between text-xs">
        <span style={{ color: 'var(--color-text-secondary)' }}>
          {doneCount} of {items.length} complete
        </span>
        <span style={{ color: requiredRemaining ? 'var(--color-warning-600)' : 'var(--color-success-600)' }}>
          {requiredRemaining ? `${requiredRemaining} required outstanding` : 'All required items complete'}
        </span>
      </div>
      <ProgressBar value={pct} accent={requiredRemaining ? 'warning' : 'success'} className="mb-4" />
      <ul className="space-y-1.5">
        {items.map((item) => (
          <li key={item.id}>
            <label
              className={cn(
                'flex items-center gap-3 rounded-lg px-2 py-2 transition-colors',
                !readOnly && 'cursor-pointer hover:bg-[var(--color-hover-background)]',
              )}
            >
              <span
                className={cn('flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-md border')}
                style={{
                  backgroundColor: item.done ? 'var(--color-success-500)' : 'transparent',
                  borderColor: item.done ? 'var(--color-success-500)' : 'var(--color-border-medium)',
                  color: '#fff',
                }}
              >
                {item.done && <FaCheck className="h-2.5 w-2.5" />}
              </span>
              <input
                type="checkbox"
                className="sr-only"
                checked={item.done}
                disabled={readOnly}
                onChange={(e) => onToggle?.(item.id, e.target.checked)}
              />
              <span
                className={cn('text-sm', item.done && 'line-through')}
                style={{ color: item.done ? 'var(--color-text-secondary)' : 'var(--color-text-primary)' }}
              >
                {item.label}
                {item.required && (
                  <span className="ml-1.5 text-xs font-semibold" style={{ color: 'var(--color-error-500)' }}>
                    *
                  </span>
                )}
              </span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};
